const formatDate = (dateString: string, divider: string = '/'): number[] => {
    const [d, m, y] = dateString.split(divider);
    return [parseInt(y, 10), parseInt(m, 10) - 1, parseInt(d, 10)]; // convert dateString from dd-mm-yyyy to [yyyy,mm,dd] format
};
export default formatDate;
